import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/provide/auth.service';
import { CommonService } from 'src/app/provide/common.service';
declare var $;
@Component({
    selector: 'app-retailer-order-list-view',
    templateUrl: './retailer-order-list-view.component.html',
    styleUrls: ['./retailer-order-list-view.component.scss'],
    standalone: false
})
export class RetailerOrderListViewComponent implements OnInit {
  _id: any;
  qtyA: any;
  serviceData: any;
  idOfAddress: any;
  loggedInUserType: any;
  lng: any;
  lat: any;

  headingName: any = 'Order Details';
  linkerRouteItems: any = [
    { name: 'Home', route: '/retailer-home' },
    { name: 'Account', route: '/customer-profile' },
    { name: 'Order History', route: '/retailer-order-list' },
    { name: 'View', route: '/retailer-order-history-view' },
  ];

  constructor(
    private activatedroute: ActivatedRoute,
    public authService: AuthService,
    public commonService: CommonService,
    private router: Router
  ) {
    this.activatedroute.queryParams.subscribe((res: any) => {
      this._id = res._id;
      if (navigator && navigator.geolocation) {
        const position = (pos) => {
          this.lng = pos.coords.longitude;
          this.lat = pos.coords.latitude;
        };

        const error = (error) => {
          alert(JSON.stringify(error));
        };

        navigator.geolocation.watchPosition(position, error);
      }
    });
  }

  ngOnInit(): void {
    this.authService.loggedInUserType.subscribe((res: any) => {
      this.loggedInUserType = res;
    });
    this.loggedInUserType = this.authService.checkUserTypeLoggedIn();
    this.viewOpenOrder();
    this.viewTransection();

    navigator.geolocation.getCurrentPosition(
      () => {},
      () => {}
    );

    this.getPosition().then((pos) => {
      localStorage.setItem('location', JSON.stringify(pos));
    });
  }

  getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  viewOrderData: any = [];
  orderDataDetials: any;
  orderDataDetialsTracking: any;
  feedBackData: any;
  isFeedbackDataSubmited = false;

  viewOpenOrder() {
    let url = `order/v2/viewOrder?orderId=${this._id}`;
    this.commonService.showSpinner();
    this.commonService.getApi(url, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.commonService.hideSpinner();
          this.orderDataDetials = res['result'];
          this.orderDataDetialsTracking = res['result']['orderTracking'];
          this.viewOrderData = res['result']['myOrders'];

          // ✅ Check Feedback logic
          if (res.result.deliveryStatus == 'DELIVERED') {
            if (localStorage.getItem('userType') == 'RETAILER') {
              if (res.result.feedBack && res.result.feedBack.length) {
                this.feedBackData = [
                  { title: 'Pickup driver Feedback', type: 'PICKUP' },
                  { title: 'Customer Feedback', type: 'CUSTOMER' },
                ];
                let i = 0;
                for (const item of res.result.feedBack) {
                  this.feedBackData[i].review = item.review;
                  this.feedBackData[i].rating = item.rating;
                  i++;
                }
                this.isFeedbackDataSubmited = true;
              } else {
                this.feedBackData = [
                  { title: 'Pickup driver Feedback', type: 'PICKUP', rating: 0 },
                  { title: 'Customer Feedback', type: 'CUSTOMER', rating: 0 },
                ];
              }
            }
          }
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        this.commonService.errorToast('Server error');
      }
    );
  }

  transactionData: any;
  viewTransection() {
    let url = `order/viewOrderTransaction?orderId=${this._id}`;
    this.commonService.showSpinner();
    this.commonService.getApi(url, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.commonService.hideSpinner();
          this.transactionData = res['result'];
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        this.commonService.errorToast('Server error');
      }
    );
  }

  // ✅ PRICE
  getPrice(e: any) {
    return this.commonService.getPrice(e);
  }
  date: any = Date;

  getAddedDate(createdAt: string, days: number) {
    return new Date(createdAt).setDate(new Date(createdAt).getDate() + 3);
  }

  // ✅ OTP Modal
  openModal: boolean = false;
  markAsDone() {
    let url = `user/productMarkAsDone`;
    let data = { orderId: this._id };
    this.commonService.postApi(url, data, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.commonService.hideSpinner();
          this.openModal = true;
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        this.commonService.errorToast('Server error');
      }
    );
  }
  closeModal() {
    this.openModal = false;
  }

  // ✅ Return Request Modal Methods
  openReturnRequestPopup() {
    $('#returnRequestModal').modal('show');
  }

  closeReturnRequestPopup() {
    $('#returnRequestModal').modal('hide');
  }

  // ✅ Image Viewer for Return Request Images
  selectedImage: string = '';
  showImageViewer: boolean = false;

  openImageViewer(imageUrl: string) {
    this.selectedImage = imageUrl;
    this.showImageViewer = true;
  }

  closeImageViewer() {
    this.showImageViewer = false;
    this.selectedImage = '';
  }
  
  // ✅ Safely resolve a return request's related order item/product
  resolveReturnItem(req: any) {
    try {
      const myOrders = Array.isArray(this.viewOrderData) ? this.viewOrderData : [];
      const productIdFromReq = typeof req?.productId === 'string' ? req.productId : req?.productId?._id;
      const orderItemIdFromReq = req?.orderItemId || req?.itemId || req?.orderProductId;

      let matched: any = null;
      if (orderItemIdFromReq) {
        matched = myOrders.find((i: any) => i?._id === orderItemIdFromReq);
      }
      if (!matched && productIdFromReq) {
        matched = myOrders.find((i: any) => i?.productId?._id === productIdFromReq);
      }

      return {
        name: req?.productId?.productName || matched?.productId?.productName,
        thumbnail: matched?.productId?.thumbnail || req?.productId?.thumbnail,
        quantity: matched?.quantity || req?.quantity,
        priceSizeDetails: matched?.priceSizeDetails || req?.priceSizeDetails,
      };
    } catch (_) {
      return { name: undefined, thumbnail: undefined, quantity: undefined, priceSizeDetails: undefined };
    }
  }
updateReturnStatus(orderId: string, requestId: string, status: string) {
  const payload = { orderId, returnRequestId: requestId, status };

  this.commonService.putApi('order/returnRequest/status', payload, 1).subscribe(
    (res: any) => {
      if (res.success) {
        // Update payment status in frontend
        this.orderDataDetials.paymentStatus = res.data.paymentStatus;

        // Update only the status of the return request without removing any items
        this.orderDataDetials.returnRequests = this.orderDataDetials.returnRequests.map(req =>
          req._id === requestId ? { ...req, status } : req
        );

        // Show success toast
        this.commonService.successToast(res.message);
      } else {
        this.commonService.errorToast(res.message);
      }
    },
    (err) => {
      this.commonService.errorToast("Server error");
    }
  );
}




  // ✅ Feedback
  itemSplit() {}
  submitFeedBack(event) {
    let url = `feedback/submitFeedback`;
    this.commonService.showSpinner();
    this.commonService.postApi(url, { feedBackData: event }, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.viewOpenOrder();
          this.commonService.successToast(res['responseMessage']);
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        this.commonService.errorToast('Server error');
      }
    );
  }
}
